import React, { useEffect, useRef, useState } from "react";
import AsyncSelect from "react-select/async";
import { showToast } from "../helper-methods";
import {
  googlePlaceDetails,
  googlePlaceSearch,
} from "../helper-methods/googleService";
import { countryCodes } from "../config/country-codes";

const GoogleMapInput = ({ onChange, disabled, value }) => {
  const searchInputTimerRef = useRef({ current: null });

  const [inputValue, setInputValue] = useState(null);

  const _googlePlaceSearch = async (searchInput) => {
    return new Promise((resolve) => {
      if (searchInputTimerRef?.current)
        clearTimeout(searchInputTimerRef.current);

      searchInputTimerRef.current = setTimeout(async () => {
        const result = await googlePlaceSearch(searchInput);

        if (!result?.length) resolve([]);

        const formatResult = result.map((each) => ({
          ...each,
          label: each.description,
          value: each.place_id,
        }));

        resolve(formatResult);
      }, 1000);
    });
  };

  const _onChange = async (e) => {
    setInputValue(e);

    if (onChange) {
      const detail = await googlePlaceDetails(e.place_id);

      const address = {};

      if (detail?.lat || detail?.lng) {
        address["street"] = detail.address;
        address["city"] = detail.city;
        address["county"] = detail.county;
        // const state = StatesConfig["IN"].find(
        //   (state) => state.name === detail.state
        // )?.code;
        address["state"] = detail.state;
        address["pinCode"] = detail.postal;
        const country = countryCodes.find(
          (state) => state.name === detail.country
        )?.code;
        address["country"] = country;
        address["description"] = `${e.description?.split(",")[0]}, ${
          e.description?.split(",")[1]
        }`;
      } else {
        setInputValue(null);
        showToast("Invalid Address", "error");
        return;
      }

      onChange(address);
    }
  };

  useEffect(() => {
    setInputValue((prev) => (value ? { ...prev, label: value } : null));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <AsyncSelect
      placeholder="Search Address"
      cacheOptions
      defaultOptions
      loadOptions={_googlePlaceSearch}
      value={inputValue}
      onChange={(e) => _onChange(e)}
      isDisabled={disabled ? true : false}
      menuShouldScrollIntoView={false}
      classNamePrefix="react-select"
      className="react-select-container"
    />
  );
};

export default GoogleMapInput;
